import { CircularProgress, Icon, IconButton, ListItem, ListItemSecondaryAction, Tooltip } from '@material-ui/core';
import Truncate from 'components/Truncate';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable } from 'react-use-observable';
import { empty } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import chargebackService from 'v2/services/chargeback';

import type { IChargebackFiles } from 'v2/interfaces/chargeback';

interface IProps {
  data: IChargebackFiles;
  invoiceId: number;
  setUpload: () => void;
}

const ChargebackDetailsListItem = ({ data, invoiceId, setUpload }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);

  const [removeFile] = useCallbackObservable(() => {
    setLoading(true);
    return chargebackService.removeChargebackFile(invoiceId, data.id).pipe(
      tap(() => {
        setUpload();
        setShow(false);
        toast.success('Arquivo excluído com sucesso!');
      }),
      catchError(() => {
        toast.error('Falha ao excluir arquivo');
        return empty();
      }),
      finalize(() => setLoading(false))
    );
  }, [invoiceId, data]);

  if (!show) return null;

  return (
    <ListItem>
      <Tooltip placement='top' title={`${data.name}.${data.ext}`}>
        <Truncate count={40} final={'...'}>{`${data.name}.${data.ext}`}</Truncate>
      </Tooltip>
      <ListItemSecondaryAction>
        <IconButton onClick={removeFile}>{loading ? <CircularProgress size={25} /> : <Icon>clear</Icon>}</IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default ChargebackDetailsListItem;
